import React from 'react';
import { FadeIn } from './FadeIn';
export function ProductVisual() {
  return <section className="py-24 px-6 bg-dark border-y border-gold/10" data-id="element-124">
      <div className="max-w-4xl mx-auto text-center" data-id="element-125">
        <FadeIn data-id="element-126">
          <h2 className="font-heading text-3xl md:text-4xl text-cream mb-6" data-id="element-127">
            Elegant Design.{' '}
            <span className="text-gold italic" data-id="element-128">Premium Quality.</span>
          </h2>
          <p className="text-lg text-cream-dark/70 mb-12" data-id="element-129">
            Beautifully crafted 6" x 8" sign that complements any event decor.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-130">
          <div className="relative max-w-2xl mx-auto" data-id="element-131">
            {/* Subtle backdrop glow */}
            <div className="absolute inset-0 bg-gold/5 blur-3xl rounded-full" data-id="element-132"></div>
            <img src="https://cdn.magicpatterns.com/uploads/p1sjJs2csAVVHkPyijNddr/heylloyd-image-1776622276664.png" alt="Close up of TapShare sign" className="relative z-10 w-full h-auto rounded-2xl border border-gold/20 shadow-2xl" data-id="element-133" />

            {/* Dimension markers */}
            <div className="absolute -left-8 top-1/2 -translate-y-1/2 flex flex-col items-center gap-2 hidden md:flex" data-id="element-134">
              <div className="w-px h-24 bg-gold/50" data-id="element-135"></div>
              <span className="text-gold text-sm font-medium rotate-180" style={{
              writingMode: 'vertical-rl'
            }} data-id="element-136">
                8 INCHES
              </span>
              <div className="w-px h-24 bg-gold/50" data-id="element-137"></div>
            </div>

            <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 hidden md:flex" data-id="element-138">
              <div className="h-px w-24 bg-gold/50" data-id="element-139"></div>
              <span className="text-gold text-sm font-medium" data-id="element-140">6 INCHES</span>
              <div className="h-px w-24 bg-gold/50" data-id="element-141"></div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}